import image1 from "../assets/Coach_1.jpg";
import image2 from "../assets/Coach_2.jpg";
import image3 from "../assets/Coach_3.jpg";
import image4 from "../assets/Coach_4.jpg";
import image5 from "../assets/Coach_5.jpg";
import image6 from "../assets/Coach_6.jpg";
import image7 from "../assets/Coach_7.jpg";
import image8 from "../assets/Coach_8.jpg";
import image9 from "../assets/Coach_9.jpg";
import image10 from "../assets/Coach_10.jpg";

export const CoachData = [
  {
    image: image1,
    review:
    "Proud to be part of this fitness family, where I can channel my passion for health and wellness into personalized training that sparks positive change.",
    name: 'Arjun', 
    status : 'Wellness Expert (PRO)'
  },
  {
    image: image2,
    review: 
    "Lorem ipIn my journey as a fitness coach, this center stands out for its commitment to individual growth. Join us in the pursuit of a stronger, healthier lifestyle.sum dolor sit amet consectetur adipisicing elit. Commodi ipsam, ab itaque nam perferendis impedit sint 2",
      
    name: 'Vikram',
    status: 'Transformation Specialist (PRO)'
  },
  {
    image : image3,
    review:
    "Thrilled to be part of a fitness community that values each person's unique journey. Witnessing transformations here is both humbling and inspiring.",
    name: 'Priya',
    status: "Head Trainer (PRO)"
  },
  {
    image: image4,
    review:
        "As a coach, I've found my second home in this center—a place that fosters dedication, celebrates milestones, and champions holistic well-being.",    
        name: 'Aashish',
    status : 'Strength & Conditioning Guru (Premium)'
  },{
    image: image5,
    review:
    "Join me in embracing the joy of fitness at this center, where every session is an opportunity to redefine limits and discover the strength within.", 
    name: 'Vishnu',
    status : 'Fitness Enthusiast (Premium)'
  },{
    image: image6,
    review:
    "Experience the impact of tailored fitness guidance in a community that prioritizes your goals. It's a privilege to contribute to the success stories unfolding here.",
    name: 'Chandu',
    status : 'Holistic Wellness Coach (Premium)'
  },{
    image: image7,
    review:
    "This fitness center is more than a workplace; it's a canvas for me to create meaningful fitness journeys. Join us, and let's sculpt a healthier future together.",
    name: 'Harsha',
    status : 'Performance Coach (Premium)'
  },{
    image: image8,
    review:
    "Joining this fitness team has been a revelation. The commitment to individualized training and the camaraderie here make it an exceptional place to inspire change.",
    name: 'Krishna',
    status : 'Cardio King (Basic)'
  },
  {
    image: image9,
    review:
    "Grateful to be a part of a fitness center that values expertise and fosters a culture of continual growth. Let's embark on your fitness journey together.",
    name: 'Rahul',
    status : 'Flexibility Specialist (Basic)'
  },{
    image: image10,
    review:
    "Every day as a coach in this center brings new stories of determination and triumph. It's a privilege to guide individuals toward their fitness goals in this vibrant community.",
        name: 'Tillu',
    status : 'Specialist (Basic)'
  }



















];
